module.exports = "https://coursera_assets.s3.amazonaws.com/images/ab7adb31b6400547d48ee4dd30f53fa8.svg";